/**
 * @generated SignedSource<<d0a54a5fcc8b0f9aa4450eeaaeb3c13b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventState = "READY" | "WAITING" | "%future added value";
export type SeriesState = "READY" | "WAITING" | "%future added value";
export type SharedSeriesManageQuery$variables = {
  id: string;
};
export type SharedSeriesManageQuery$data = {
  readonly series: {
    readonly acl: ReadonlyArray<{
      readonly actions: ReadonlyArray<string>;
      readonly info: {
        readonly implies: ReadonlyArray<string> | null | undefined;
        readonly label: { default: string } & Record<string, string | undefined>;
        readonly large: boolean;
      } | null | undefined;
      readonly role: string;
    }>;
    readonly created: string | null | undefined;
    readonly description: string | null | undefined;
    readonly entries: ReadonlyArray<{
      readonly __typename: "AuthorizedEvent";
      readonly canWrite: boolean;
      readonly created: string;
      readonly creators: ReadonlyArray<string>;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly isLive: boolean;
      readonly syncedData: {
        readonly audioOnly: boolean;
        readonly duration: number;
        readonly endTime: string | null | undefined;
        readonly startTime: string | null | undefined;
        readonly thumbnail: string | null | undefined;
      } | null | undefined;
      readonly title: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }>;
    readonly hostRealms: ReadonlyArray<{
      readonly id: string;
      readonly isMainRoot: boolean;
      readonly name: string | null | undefined;
      readonly path: string;
    }>;
    readonly id: string;
    readonly state: SeriesState;
    readonly thumbnailStack: {
      readonly thumbnails: ReadonlyArray<{
        readonly audioOnly: boolean;
        readonly live: boolean;
        readonly state: EventState;
        readonly url: string | null | undefined;
      }>;
    };
    readonly title: string;
    readonly tobiraDeletionTimestamp: string | null | undefined;
    readonly updated: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AccessKnownRolesData" | "UserData">;
};
export type SharedSeriesManageQuery = {
  response: SharedSeriesManageQuery$data;
  variables: SharedSeriesManageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updated",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "implies",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "large",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "AclItemWithInfo",
  "kind": "LinkedField",
  "name": "acl",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoleInfo",
      "kind": "LinkedField",
      "name": "info",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tobiraDeletionTimestamp",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audioOnly",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "ThumbnailStack",
  "kind": "LinkedField",
  "name": "thumbnailStack",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ThumbnailInfo",
      "kind": "LinkedField",
      "name": "thumbnails",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "live",
          "storageKey": null
        },
        (v14/*: any*/),
        (v12/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLive",
      "storageKey": null
    },
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creators",
      "storageKey": null
    },
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SyncedEventData",
      "kind": "LinkedField",
      "name": "syncedData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": null
        },
        (v14/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AuthorizedEvent",
  "abstractKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Realm",
  "kind": "LinkedField",
  "name": "hostRealms",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMainRoot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SharedSeriesManageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UserData"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AccessKnownRolesData"
      },
      {
        "alias": "series",
        "args": (v1/*: any*/),
        "concreteType": "Series",
        "kind": "LinkedField",
        "name": "seriesById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "entries",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SharedSeriesManageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRealmHandle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUpload",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseStudio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseEditor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateUserRealm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateSeries",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreatePlaylists",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTobiraAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canFindUnlisted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roles",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRole",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "KnownGroup",
        "kind": "LinkedField",
        "name": "knownGroups",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sortKey",
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "series",
        "args": (v1/*: any*/),
        "concreteType": "Series",
        "kind": "LinkedField",
        "name": "seriesById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "entries",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a34b855e66951d6884fe4e6945be260d",
    "id": null,
    "metadata": {},
    "name": "SharedSeriesManageQuery",
    "operationKind": "query",
    "text": "query SharedSeriesManageQuery(\n  $id: ID!\n) {\n  ...UserData\n  ...AccessKnownRolesData\n  series: seriesById(id: $id) {\n    id\n    title\n    created\n    updated\n    acl {\n      role\n      actions\n      info {\n        label\n        implies\n        large\n      }\n    }\n    description\n    state\n    tobiraDeletionTimestamp\n    thumbnailStack {\n      thumbnails {\n        url\n        live\n        audioOnly\n        state\n      }\n    }\n    entries {\n      __typename\n      ... on AuthorizedEvent {\n        id\n        isLive\n        title\n        created\n        creators\n        description\n        canWrite\n        syncedData {\n          thumbnail\n          audioOnly\n          duration\n          startTime\n          endTime\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    hostRealms {\n      id\n      isMainRoot\n      name\n      path\n    }\n  }\n}\n\nfragment AccessKnownRolesData on Query {\n  knownGroups {\n    role\n    label\n    implies\n    sortKey\n    large\n  }\n}\n\nfragment UserData on Query {\n  currentUser {\n    username\n    displayName\n    userRealmHandle\n    canUpload\n    canUseStudio\n    canUseEditor\n    canCreateUserRealm\n    canCreateSeries\n    canCreatePlaylists\n    isTobiraAdmin\n    canFindUnlisted\n    roles\n    userRole\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e5737700d3a3d33389369387795e9c8";

export default node;
